module.exports = "/static/assets/ae6356a420075d537e2388245d4ae0c1.png";